export default {
  getConvertedImage: (state) => (originalUrl) => {
    return state.convertedImages[originalUrl] || null;
  },

  getConversionStatus: (state) => (url) => {
    return state.conversionStatus[url] || null;
  },

  isConverted: (state) => (originalUrl) => {
    return !!state.convertedImages[originalUrl];
  },

  isConverting: (state) => (originalUrl) => {
    return state.conversionStatus[originalUrl] === 'pending';
  }
};
